import withScroll from '../hoc/withScroll'
import scrollManager from '../utils/scrollManager'

export default withScroll({
  name: 'header',

  ui: {
    burger: '[js-header-burger]',
    'navs[]': '[js-header-nav]',
    'links[]': '[js-header-link]',
    cart: '[js-header-cart]',
  },

  events: [
    {
      target: 'burger',
      on: 'click',
      handle () {
        this.el.classList.toggle('is-active')
        this.el.classList.remove('is-open')

        if (this.el.classList.contains('is-active')) {
          scrollManager.stop()
        } else {
          scrollManager.restart()
        }

        document.querySelector('[js-search-panel]').classList.remove('is-visible')

        this.ui.navs.forEach(item => {
          item.classList.remove('is-hovered')

          const navOpen = item.querySelector('.is-open')
          if (navOpen) {
            navOpen.classList.remove('is-open')
          }
        })
      },
    },
    {
      target: 'cart',
      on: 'click',
      handle (e) {
        e.preventDefault()
        window.location = e.target.href
      },
    },
    {
      target: 'links',
      on: 'click',
      handle (e) {
        const parent = e.target.parentNode

        if (window.innerWidth < 1024 && parent.querySelector('.dropdown')) {
          const openEl = document.querySelectorAll('.header .is-open')
          e.preventDefault()

          if (openEl.length > 0 && openEl[0] !== parent) {
            openEl[0].classList.remove('is-open')
          }

          parent.classList.toggle('is-open')
        }
      },
    },
  ],

  topBannerHeight: 0,

  componentDidMount () {
    this.topBanner = document.querySelector('.top-banner')

    if (this.topBanner) {
      this.topBannerHeight = this.topBanner.offsetHeight
    }
  },

  onScroll ({ y }) {
    if (y > this.topBannerHeight) {
      this.el.classList.add('is-fixed')
    } else {
      this.el.classList.remove('is-fixed')
    }
  },
})
